
<!-- routed child content -->
<router-outlet></router-outlet>
